import { loadStripe } from '@stripe/stripe-js';

// Initialize Stripe with your publishable key
// Add your Stripe publishable key to .env file:
// REACT_APP_STRIPE_PUBLISHABLE_KEY=pk_test_your_actual_key_here
const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY || 'pk_test_51H1234567890abcdefghijklmnopqrstuvwxyz');

export default stripePromise; 